(function () {
  "use strict";

  var BUYERS_API_URL = "https://api-gateway.bulkit.uk/api/buyers/";
  var BUYERS_ASSETS_UPLOAD_URL =
    "https://api-gateway.bulkit.uk/api/assets/upload/";

  async function getSignature(customerId, secret) {
    var key = await crypto.subtle.importKey(
      "raw",
      new TextEncoder().encode(secret),
      { name: "HMAC", hash: "SHA-256" },
      false,
      ["sign"],
    );
    var raw = await crypto.subtle.sign(
      "HMAC",
      key,
      new TextEncoder().encode(String(customerId)),
    );
    return btoa(String.fromCharCode(...new Uint8Array(raw)));
  }

  function fieldToMetadataKey(label) {
    return String(label)
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "_")
      .replace(/[^a-z0-9_+]/g, "");
  }

  function collectContactFields(formEl) {
    var fd = new FormData(formEl);
    var contact = {};
    var files = [];

    fd.forEach(function (value, key) {
      var match = key.match(/^contact\[(.+)\]$/);
      if (!match) return;
      var field = match[1];
      if (value instanceof File) {
        if (field === "attachment" && value.size > 0) files.push(value);
        return;
      }
      if (value === "") return;
      if (Object.prototype.hasOwnProperty.call(contact, field)) {
        if (!Array.isArray(contact[field])) contact[field] = [contact[field]];
        contact[field].push(value);
      } else {
        contact[field] = value;
      }
    });

    return { contact: contact, files: files };
  }

  function buildBuyersApiPayload(formEl) {
    var collected = collectContactFields(formEl);
    var c = collected.contact;

    var firstName = c["First name"] || "";
    var lastName = c["Last name"] || "";
    var name = (firstName + " " + lastName).trim() || c.name || "";
    var email = c.email || "";
    var phoneRaw = String(c.Phone || "").trim();
    var phoneFormatted =
      "+44" + phoneRaw.replace(/[\s\-()+]/g, "").replace(/^0/, "");

    var storeName = c["Store name"] || "";

    var activeTab = formEl.querySelector(".buyer-reg__tab--active");
    var tabType = activeTab && activeTab.getAttribute("data-type");
    var business_type = tabType === "individual" ? "INDIVIDUAL" : "COMPANY";

    var metadata = {
      source: "website",
      country: c["Country"] || "UK",
      is_signup: true,
    };

    var address = {};
    if (firstName) address.first_name = firstName;
    if (lastName) address.last_name = lastName;
    if (c["Address line 1"]) address.address1 = c["Address line 1"];
    if (c["Address line 2"]) address.address2 = c["Address line 2"];
    if (c["City"]) address.city = c["City"];
    if (c["Postcode"]) address.zip = c["Postcode"];
    if (c["County"]) address.province = c["County"];
    if (c["Country"]) address.country = c["Country"];
    if (phoneFormatted) address.phone = phoneFormatted;
    if (Object.keys(address).length) metadata.address = address;

    var skip = {
      "First name": true,
      "Last name": true,
      email: true,
      Phone: true,
      "Store name": true,
      "Terms accepted": true,
      "Age confirmation": true,
      "Lawful use": true,
      "Address line 1": true,
      "Address line 2": true,
      City: true,
      Postcode: true,
      County: true,
      Country: true,
    };

    Object.keys(c).forEach(function (key) {
      if (skip[key]) return;
      var val = c[key];
      var mk = fieldToMetadataKey(key);
      if (mk) metadata[mk] = val;
    });

    var payload = {
     name: String(name).trim(),
     email: String(email).trim(),
      phone: phoneFormatted,
       business_type: business_type,
     metadata: metadata,
    };

if (business_type === "INDIVIDUAL") {
  // Read the age checkbox directly from the DOM.
  // Do not rely on FormData's checkbox value ("Yes"/"on"/etc.).
  var ageConfirmationCheckbox = formEl.querySelector(
    "[data-age-confirmation]"
  );

  payload.age_confirmation = !!(
    ageConfirmationCheckbox && ageConfirmationCheckbox.checked
  );

  // Read DOB directly from the actual DOB input.
  // Some date-picker/browser implementations can show a value
  // visually while FormData does not contain it.
  var dobInput = formEl.querySelector(
    '[data-validation-type="dob"]'
  );
  var dobRaw = dobInput
    ? String(dobInput.value || "").trim()
    : String(c["Date of birth"] || "").trim();

  if (dobRaw) {
    payload.metadata = payload.metadata || {};
    payload.metadata.date_of_birth = dobRaw;

    // The API serializer expects date_of_birth as a top-level field
    // in YYYY-MM-DD format. Keep metadata.date_of_birth in DD/MM/YYYY
    // because the server-side age check reads that value.
    var dobParts = dobRaw.split("/");
    if (dobParts.length === 3) {
      payload.date_of_birth =
        dobParts[2] + "-" + dobParts[1] + "-" + dobParts[0];
    }
  }
}


    if (String(storeName).trim()) {
      payload.store_name = String(storeName).trim();
    }

    return payload;
  }

  function setStatus(statusEl, type, message) {
    if (!statusEl) return;
    statusEl.innerHTML = "";
    statusEl.hidden = true;
    statusEl.innerHTML = "";
    statusEl.hidden = true;
    statusEl.className = "buyer-reg__status";

    if (!message || (Array.isArray(message) && message.length === 0)) return;

    var messages = Array.isArray(message) ? message : [message];
    statusEl.hidden = false;

    if (messages.length === 1) {
      statusEl.classList.add(
        type === "success"
          ? "buyer-reg__status--success"
          : "buyer-reg__status--error",
      );
      statusEl.textContent = messages[0];
    } else {
      statusEl.classList.add("buyer-reg__status--multi");
      messages.forEach(function (m) {
        var item = document.createElement("div");
        item.className = "buyer-reg__status buyer-reg__status--error";
        item.textContent = m;
        statusEl.appendChild(item);
      });
    }
  }

  function showBuyerSuccess(root, formEl, email, businessType) {
    if (!root || !formEl) return;
    var shell = root.querySelector("[data-buyer-form-shell]");
    var successEl = root.querySelector("[data-buyer-success]");
    var loginCta = root.querySelector("[data-login-cta]");
    var heroEl = root.querySelector(".buyer-reg__hero");
    var statusEl = formEl.querySelector("[data-buyer-status]");
    setStatus(statusEl, null, "");
    if (shell) shell.hidden = true;
    if (loginCta) loginCta.hidden = true;
    if (heroEl) heroEl.hidden = true;
    if (successEl) {
      if (email) {
        var emailEl = successEl.querySelector("[data-success-email]");
        if (emailEl) emailEl.textContent = email;
      }
      if (businessType === "INDIVIDUAL") {
        var infoCard = successEl.querySelector(".buyer-reg__success-info-card");
        if (infoCard) infoCard.hidden = true;
        var subtitle = successEl.querySelector(".buyer-reg__success-subtitle");
        if (subtitle) {
          var loginUrl =
            successEl.getAttribute("data-login-url") || "/account/login";
          subtitle.innerHTML =
            'Filled form? Now <a href="' +
            loginUrl +
            '" class="buyer-reg__login-link button button--secondary link focus-inset">Sign in</a>';
        }
        var signinEl = successEl.querySelector(".buyer-reg__success-signin");
        if (signinEl) signinEl.hidden = true;
      }
      successEl.hidden = false;
      successEl.focus();
    }
  }

  function uploadBuyerAsset(buyerId, files, fileType, replace) {
    if (buyerId == null || buyerId === "" || !files || files.length === 0)
      return;
    var fd = new FormData();
    fd.append("file_type", fileType);
    fd.append("content_type", "buyers.buyer");
    fd.append("object_id", String(buyerId));
    if (replace) fd.append("replace", "true");
    files.forEach(function (file) {
      fd.append("files", file);
    });
    return fetch(BUYERS_ASSETS_UPLOAD_URL, {
      method: "POST",
      body: fd,
    });
  }

  function uploadBuyerProofOfAge(buyerId, files, replace) {
    return uploadBuyerAsset(buyerId, files, "BUYER_PROOF_OF_AGE", replace);
  }

  // Proof-of-age upload is mandatory once the age confirmation is checked.
  // Only enforced in individual mode (file input enabled) for new signups —
  // existing buyers already have a document on record (upload optional/replaces).
  function isAgeProofSatisfied(formEl) {
    var checkbox = formEl.querySelector("[data-age-confirmation]");
    var fileInput = formEl.querySelector("[data-age-proof-input]");
    if (!checkbox || !fileInput) return true;
    if (fileInput.disabled) return true;
    if (!checkbox.checked) return true;
    var root = formEl.closest("[data-buyer-registration]");
    var existingBuyerId = root && root.getAttribute("data-buyer-id");
    if (existingBuyerId && existingBuyerId.trim()) return true;
    return !!(fileInput.files && fileInput.files.length > 0);
  }

  function showAgeProofError(formEl, message) {
    var selectedEl = formEl.querySelector("[data-age-upload-selected]");
    if (!selectedEl) return;
    selectedEl.textContent = message || "";
    selectedEl.className = message
      ? "buyer-reg__age-upload-selected buyer-reg__age-upload-selected--error"
      : "buyer-reg__age-upload-selected";
    selectedEl.hidden = !message;
  }

  function validateField(field) {
    if (!field) return true;

    // Checkboxes: validate checked state, not value
    if (field.type === "checkbox") {
      var msg =
        field.hasAttribute("required") && !field.checked
          ? "This field is required"
          : "";
      displayFieldError(field, msg);
      return !msg;
    }

    var validationType = field.getAttribute("data-validation-type");
    var value = field.value.trim();
    var isValid = true;
    var errorMessage = "";

    if (field.hasAttribute("required") && !value) {
      isValid = false;
      errorMessage = "This field is required";
    } else if (value) {
      switch (validationType) {
        case "name":
          if (value.length < 2) {
            isValid = false;
            errorMessage = "Name must be at least 2 characters";
          } else if (!/^[a-zA-Z\s\-']+$/.test(value)) {
            isValid = false;
            errorMessage = "Name can only contain letters, spaces, and hyphens";
          }
          break;
        case "email":
          if (!field.checkValidity()) {
            isValid = false;
            errorMessage = "Please enter a valid email address";
          }
          break;
        case "phone": {
          var phoneDigits = value.replace(/\s/g, "");
          if (!/^\d{10}$/.test(phoneDigits)) {
            isValid = false;
            errorMessage = "Please enter a valid 10-digit phone number";
          }
          break;
        }
        case "dob": {
          var dobMatch = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
          if (!dobMatch) {
            isValid = false;
            errorMessage = "Please use DD/MM/YYYY format";
          } else {
            var dd = parseInt(dobMatch[1], 10);
            var mm = parseInt(dobMatch[2], 10);
            var yyyy = parseInt(dobMatch[3], 10);
            var dob = new Date(yyyy, mm - 1, dd);
            if (
              isNaN(dob.getTime()) ||
              dob.getMonth() !== mm - 1 ||
              dob.getDate() !== dd
            ) {
              isValid = false;
              errorMessage = "Please enter a valid date";
            } else {
              var today = new Date();
              var age = today.getFullYear() - dob.getFullYear();
              var mDiff = today.getMonth() - dob.getMonth();
              if (mDiff < 0 || (mDiff === 0 && today.getDate() < dob.getDate()))
                age--;
              if (age < 18) {
                isValid = false;
                errorMessage = "You must be 18 or older to register";
              }
            }
          }
          break;
        }
        // case "vat":
        //   if (!/^[0-9]{9,10}$/.test(value)) {
        //     isValid = false;
        //     errorMessage = "Enter a valid VAT number";
        //   }
        //   break;
        //  case "vat": {
        //   var vatDigits = value.toUpperCase().replace(/^GB/, "").replace(/\s/g, "");
        //   if (!/^[0-9]{9}$/.test(vatDigits)) {
        //     isValid = false;
        //     errorMessage = "Enter a valid VAT number (9 digits, e.g. GB123456789)";
        //   }
        //   break;
        // }
        case "vat":
          {
            var vatNorm = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
            if (!/^(GB|XI)/.test(vatNorm)) vatNorm = "GB" + vatNorm;
            if (!/^(GB|XI)(\d{9}|\d{12}|GD\d{3}|HA\d{3})$/.test(vatNorm)) {
              isValid = false;
              errorMessage =
                "Enter a valid VAT number (e.g. 123456789 or GD123)";
            } else {
              field.value = vatNorm;
            }
            break;
          }
          break;
        case "companies-house":
          if (!/^[0-9A-Z]{6,10}$/.test(value.toUpperCase())) {
            isValid = false;
            errorMessage = "Enter a valid Companies House number";
          }
          break;
        case "select":
          if (!value) {
            isValid = false;
            errorMessage = "Please select an option";
          }
          break;
      }
    }

    displayFieldError(field, errorMessage);
    return isValid;
  }

  function displayFieldError(field, message) {
    var errorElement = null;
    if (field.form) {
      errorElement = field.form.querySelector(
        '[data-error-for="' + field.id + '"]',
      );
    }
    if (errorElement) {
      errorElement.textContent = message;
    }
    var fieldWrapper =
      field.closest(".buyer-reg__field") ||
      field.closest(".buyer-reg__declaration");
    if (fieldWrapper) {
      if (message) {
        fieldWrapper.classList.add("has-error");
      } else {
        fieldWrapper.classList.remove("has-error");
      }
    }
  }

  function validateStep(formEl, stepNum) {
    var stepContent = formEl.querySelector(
      '[data-step-content="' + stepNum + '"]',
    );
    if (!stepContent) return true;

    var inputs = stepContent.querySelectorAll(
      "input[required]:not(:disabled), select[required]:not(:disabled), textarea[required]:not(:disabled)",
    );
    var isValid = true;

    inputs.forEach(function (input) {
      if (!validateField(input)) isValid = false;
    });

    // Step 2: business sector badge must be selected
    if (stepNum === 2) {
      var sectorInput = stepContent.querySelector(
        '[name="contact[Business sector]"]',
      );
      if (sectorInput) {
        var sectorErrEl = formEl.querySelector(
          '[data-error-for="' + sectorInput.id + '"]',
        );
        var sectorFieldEl = sectorInput.closest(".buyer-reg__field");
        if (!sectorInput.value) {
          isValid = false;
          if (sectorErrEl)
            sectorErrEl.textContent = "Please select a business sector";
          if (sectorFieldEl) sectorFieldEl.classList.add("has-error");
        } else {
          if (sectorErrEl) sectorErrEl.textContent = "";
          if (sectorFieldEl) sectorFieldEl.classList.remove("has-error");
        }
      }
    }

    return isValid;
  }

  function bindFieldValidation() {}

  function populateReview(formEl, sectionId) {
    var fd = collectContactFields(formEl);
    var c = fd.contact;

    var firstName = c["First name"] || "";
    var lastName = c["Last name"] || "";
    var fullName = (firstName + " " + lastName).trim();

    var phone = c.Phone ? "+44 " + c.Phone : "";

    // Contact card
    var rvName = formEl.querySelector("[data-rv-name]");
    var rvEmail = formEl.querySelector("[data-rv-email]");
    var rvPhone = formEl.querySelector("[data-rv-phone]");
    if (rvName) rvName.textContent = fullName;
    if (rvEmail) rvEmail.textContent = c.email || "";
    if (rvPhone) rvPhone.textContent = phone;

    // Company card
    var rvCompanyName = formEl.querySelector("[data-rv-company-name]");
    var rvCompanyMeta = formEl.querySelector("[data-rv-company-meta]");
    var rvCompanySector = formEl.querySelector("[data-rv-company-sector]");
    if (rvCompanyName)
      rvCompanyName.textContent = c["Business name"] || c["Trading name"] || "";
    if (rvCompanyMeta) {
      var meta = [];
      if (c["Company type"]) meta.push(c["Company type"]);
      if (c["Companies House number"])
        meta.push("CH " + c["Companies House number"]);
      if (c["VAT number"]) meta.push("VAT GB" + c["VAT number"]);
      rvCompanyMeta.textContent = meta.join(" · ");
    }
    if (rvCompanySector) {
      rvCompanySector.textContent = c["Business sector"]
        ? "Sector: " + c["Business sector"]
        : "";
    }

    // Address card
    var rvAddr1 = formEl.querySelector("[data-rv-addr1]");
    var rvAddr2 = formEl.querySelector("[data-rv-addr2]");
    if (rvAddr1)
      rvAddr1.textContent = [c["Address line 1"], c["Address line 2"]]
        .filter(Boolean)
        .join(", ");
    if (rvAddr2) {
      var addrParts = [];
      if (c["City"]) addrParts.push(c["City"]);
      if (c["Postcode"]) addrParts.push(c["Postcode"]);
      if (c["Country"]) addrParts.push(c["Country"]);
      rvAddr2.textContent = addrParts.join(", ");
    }
  }

  function updateStepperProgress(formEl, currentStep, totalSteps) {
    var progressBar = formEl.querySelector("[data-stepper-progress]");
    if (!progressBar) return;
    // Each segment covers 1/(totalSteps-1) of the bar
    var pct = ((currentStep - 1) / (totalSteps - 1)) * 100;
    progressBar.style.width = pct + "%";
  }

  function showStep(formEl, stepNum, totalSteps, sectionId) {
    // Hide all step content
    formEl.querySelectorAll("[data-step-content]").forEach(function (el) {
      el.hidden = true;
    });
    var stepContent = formEl.querySelector(
      '[data-step-content="' + stepNum + '"]',
    );
    if (stepContent) stepContent.hidden = false;

    // Update step nodes
    var stepsContainer = formEl.querySelector("[data-buyer-steps]");
    if (stepsContainer) {
      stepsContainer
        .querySelectorAll(".buyer-reg__step")
        .forEach(function (step) {
          var n = parseInt(step.getAttribute("data-step"), 10);
          step.classList.remove(
            "buyer-reg__step--active",
            "buyer-reg__step--done",
          );
          if (n < stepNum) {
            step.classList.add("buyer-reg__step--done");
          } else if (n === stepNum) {
            step.classList.add("buyer-reg__step--active");
          }
        });
    }

    // Update progress bar
    updateStepperProgress(formEl, stepNum, totalSteps);

    // Update data-current-step for CSS
    formEl.setAttribute("data-current-step", stepNum);

    // Show/hide login CTA
    var root = formEl.closest("[data-buyer-registration]");
    if (root) {
      var loginCta = root.querySelector("[data-login-cta]");
      if (loginCta) loginCta.hidden = stepNum !== 1;
    }

    // Populate review on step 4
    if (stepNum === 4) populateReview(formEl, sectionId);

    updateButtonStates(formEl, stepNum, totalSteps);
  }

  function updateButtonStates(formEl, currentStep, totalSteps) {
    var backBtn = formEl.querySelector("[data-back-button]");
    var continueBtn = formEl.querySelector("[data-continue-button]");
    var submitBtn = formEl.querySelector("[data-submit-button]");

    if (backBtn) backBtn.hidden = currentStep === 1;

    if (continueBtn && submitBtn) {
      if (currentStep === totalSteps) {
        continueBtn.hidden = true;
        submitBtn.hidden = false;
      } else {
        continueBtn.hidden = false;
        submitBtn.hidden = true;
      }
    }
  }

  function bindFormNavigation(formEl, totalSteps, sectionId) {
    var currentStep = 1;

    function getCurrentStep() {
      return currentStep;
    }

    function goToStep(step) {
      currentStep = step;
      showStep(formEl, currentStep, totalSteps, sectionId);
    }

    var backBtn = formEl.querySelector("[data-back-button]");
    var continueBtn = formEl.querySelector("[data-continue-button]");

    if (backBtn) {
      backBtn.addEventListener("click", function (e) {
        e.preventDefault();
        if (currentStep > 1) {
          var statusEl = formEl.querySelector("[data-buyer-status]");
          setStatus(statusEl, null, "");
          saveStepDraft(formEl, sectionId, currentStep);
          goToStep(currentStep - 1);
          updateDraftStep(sectionId, currentStep);
          formEl.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    }

    formEl.addEventListener("input", function (e) {
      if (
        e.target.tagName === "INPUT" ||
        e.target.tagName === "TEXTAREA" ||
        e.target.tagName === "SELECT"
      ) {
        var statusEl = formEl.querySelector("[data-buyer-status]");
        setStatus(statusEl, null, "");
      }
    });

    formEl.addEventListener("change", function (e) {
      if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT") {
        var statusEl = formEl.querySelector("[data-buyer-status]");
        setStatus(statusEl, null, "");
      }
    });

    if (continueBtn) {
      continueBtn.addEventListener("click", function (e) {
        e.preventDefault();
        if (validateStep(formEl, currentStep)) {
          if (currentStep < totalSteps) {
            saveStepDraft(formEl, sectionId, currentStep);
            goToStep(currentStep + 1);
            updateDraftStep(sectionId, currentStep);
            formEl.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      });
    }

    // "Edit" buttons in review step navigate back
    formEl.querySelectorAll("[data-edit-step]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var target = parseInt(btn.getAttribute("data-edit-step"), 10);
        if (target >= 1 && target < totalSteps) {
          saveStepDraft(formEl, sectionId, currentStep);
          goToStep(target);
          updateDraftStep(sectionId, currentStep);
          formEl.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });

    return { getCurrentStep: getCurrentStep, goToStep: goToStep };
  }

  function setContentMode(formEl, type, totalSteps) {
    var businessContent = formEl.querySelector("[data-business-content]");
    var individualContent = formEl.querySelector("[data-individual-content]");
    var backBtn = formEl.querySelector("[data-back-button]");
    var continueBtn = formEl.querySelector("[data-continue-button]");
    var submitBtn = formEl.querySelector("[data-submit-button]");

    if (type === "individual") {
      if (businessContent) {
        businessContent.hidden = true;
        businessContent
          .querySelectorAll("input:not([data-dob-picker]), select, textarea")
          .forEach(function (f) {
            f.disabled = true;
          });
      }
      if (individualContent) {
        individualContent.hidden = false;
        individualContent
          .querySelectorAll(
            "input:not([data-dob-picker]):not([data-age-proof-input]), select, textarea",
          )
          .forEach(function (f) {
            f.disabled = false;
            if (f.hasAttribute("data-customer-prefilled")) f.readOnly = true;
          });
        // Re-sync age proof upload visibility with checkbox state
        var ageCb = individualContent.querySelector("[data-age-confirmation]");
        var ageUpload = individualContent.querySelector(
          "[data-age-proof-input]",
        );
        var ageWrap = ageUpload && ageUpload.closest(".buyer-reg__age-upload");
        if (ageCb && ageUpload && ageWrap) {
          ageWrap.hidden = !ageCb.checked;
          ageUpload.disabled = !ageCb.checked;
        }
      }
      if (backBtn) backBtn.hidden = true;
      if (continueBtn) continueBtn.hidden = true;
      if (submitBtn) submitBtn.hidden = false;
    } else {
      if (individualContent) {
        individualContent.hidden = true;
        individualContent
          .querySelectorAll("input:not([data-dob-picker]), select, textarea")
          .forEach(function (f) {
            f.disabled = true;
          });
      }
      if (businessContent) {
        businessContent.hidden = false;
        businessContent
          .querySelectorAll("input:not([data-dob-picker]), select, textarea")
          .forEach(function (f) {
            f.disabled = false;
            if (f.hasAttribute("data-customer-prefilled")) f.readOnly = true;
          });
      }
      var currentStep = parseInt(
        formEl.getAttribute("data-current-step") || "1",
        10,
      );
      updateButtonStates(formEl, currentStep, totalSteps || 4);
      // Re-apply conditional field logic
      var root = formEl.closest("[data-buyer-registration]");
      if (root) {
        var sectionId = root.getAttribute("data-section-id");
        if (sectionId) updateCompanyType(sectionId);
      }
    }
  }

//  function bindDOBPicker(formEl) {
//   var yesterday = new Date();
//   yesterday.setDate(yesterday.getDate() - 1);

//   var year = yesterday.getFullYear();
//   var month = String(yesterday.getMonth() + 1).padStart(2, "0");
//   var day = String(yesterday.getDate()).padStart(2, "0");
//   var maxDate = year + "-" + month + "-" + day;

//   var isIOS =
//     /iPad|iPhone|iPod/.test(navigator.userAgent) ||
//     (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

//   formEl.querySelectorAll(".buyer-reg__dob-wrap").forEach(function (wrap) {
//     var textInput = wrap.querySelector(
//       "input[data-validation-type='dob']"
//     );
//     var pickerInput = wrap.querySelector("[data-dob-picker]");

//     if (!textInput || !pickerInput) return;

//     pickerInput.max = maxDate;

//     function syncPickerFromText() {
//       var match = textInput.value.match(
//         /^(\d{2})\/(\d{2})\/(\d{4})$/
//       );

//       if (!match) return;

//       pickerInput.value =
//         match[3] + "-" + match[2] + "-" + match[1];
//     }

//     function openPicker() {
//       if (textInput.disabled) return;

//       syncPickerFromText();

//       if (isIOS) {
//         pickerInput.focus();
//         pickerInput.click();
//         return;
//       }

//       if (typeof pickerInput.showPicker === "function") {
//         try {
//           pickerInput.showPicker();
//           return;
//         } catch (e) {
//           // Fall back to normal native interaction
//         }
//       }

//       pickerInput.focus();
//       pickerInput.click();
//     }

//     textInput.addEventListener("click", openPicker);

//     pickerInput.addEventListener("change", function () {
//       if (!pickerInput.value) return;

//       var parts = pickerInput.value.split("-");

//       if (parts.length !== 3) return;

//       textInput.value =
//         parts[2] + "/" + parts[1] + "/" + parts[0];

//       textInput.dispatchEvent(
//         new Event("input", { bubbles: true })
//       );

//       textInput.dispatchEvent(
//         new Event("change", { bubbles: true })
//       );

//       if (isIOS) {
//         textInput.focus();
//       }
//     });
//   });
// }

 
function bindDOBPicker(formEl) {
  var today = new Date();

  var maxDOB = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate()
  );

  var maxYear = maxDOB.getFullYear();

  /*
   * Safari detection
   *
   * Chrome / Edge / Firefox will NOT enter
   * this Safari-specific branch.
   */
  var ua = navigator.userAgent;

  var isSafari =
    /Safari/i.test(ua) &&
    !/Chrome|CriOS|Chromium|Edg|OPR|FxiOS/i.test(ua);

  formEl
    .querySelectorAll(".buyer-reg__dob-wrap")
    .forEach(function (wrap) {
      var textInput = wrap.querySelector(
        "input[data-validation-type='dob']"
      );

      var pickerInput = wrap.querySelector(
        "[data-dob-picker]"
      );

      if (!textInput || !pickerInput) {
        return;
      }

      /*
       * Set existing native picker max date
       */
      var maxMonth = String(
        maxDOB.getMonth() + 1
      ).padStart(2, "0");

      var maxDay = String(
        maxDOB.getDate()
      ).padStart(2, "0");

      pickerInput.max =
        maxYear +
        "-" +
        maxMonth +
        "-" +
        maxDay;


      /*
       * =================================
       * NON-SAFARI
       * Keep your existing behaviour
       * =================================
       */
      if (!isSafari) {

        function syncPickerFromText() {
          var match =
            textInput.value.match(
              /^(\d{2})\/(\d{2})\/(\d{4})$/
            );

          if (!match) {
            return;
          }

          pickerInput.value =
            match[3] +
            "-" +
            match[2] +
            "-" +
            match[1];
        }


        function openPicker() {
          if (textInput.disabled) {
            return;
          }

          syncPickerFromText();

          if (
            typeof pickerInput.showPicker ===
            "function"
          ) {
            try {
              pickerInput.showPicker();
              return;
            } catch (e) {}
          }

          pickerInput.focus();
          pickerInput.click();
        }


        textInput.addEventListener(
          "click",
          openPicker
        );


        pickerInput.addEventListener(
          "change",
          function () {
            if (!pickerInput.value) {
              return;
            }

            var parts =
              pickerInput.value.split("-");

            if (parts.length !== 3) {
              return;
            }

            textInput.value =
              parts[2] +
              "/" +
              parts[1] +
              "/" +
              parts[0];

            textInput.dispatchEvent(
              new Event("input", {
                bubbles: true
              })
            );

            textInput.dispatchEvent(
              new Event("change", {
                bubbles: true
              })
            );

            validateField(textInput);
          }
        );

        return;
      }


      /*
       * =================================
       * SAFARI ONLY
       * =================================
       */

      wrap.classList.add(
        "buyer-reg__dob-wrap--safari"
      );


      /*
       * Create Safari picker dynamically.
       *
       * HTML does NOT need changing.
       */
      var safariPicker =
        document.createElement("div");

      safariPicker.className =
        "buyer-reg__safari-date-picker";

      safariPicker.hidden = true;


      /*
       * Header
       */
      var selectRow =
        document.createElement("div");

      selectRow.className =
        "buyer-reg__safari-date-selects";


      /*
       * MONTH
       */
      var monthSelect =
        document.createElement("select");

      monthSelect.className =
        "buyer-reg__safari-date-select";

      monthSelect.setAttribute(
        "aria-label",
        "Month"
      );


      var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];


      months.forEach(
        function (monthName, index) {
          var option =
            document.createElement(
              "option"
            );

          option.value =
            String(index + 1);

          option.textContent =
            monthName;

          monthSelect.appendChild(
            option
          );
        }
      );


      /*
       * YEAR
       */
      var yearSelect =
        document.createElement("select");

      yearSelect.className =
        "buyer-reg__safari-date-select";

      yearSelect.setAttribute(
        "aria-label",
        "Year"
      );


      for (
        var year = maxYear;
        year >= 1900;
        year--
      ) {
        var yearOption =
          document.createElement(
            "option"
          );

        yearOption.value =
          String(year);

        yearOption.textContent =
          String(year);

        yearSelect.appendChild(
          yearOption
        );
      }


      selectRow.appendChild(
        monthSelect
      );

      selectRow.appendChild(
        yearSelect
      );


      /*
       * Calendar days container
       */
      var calendar =
        document.createElement("div");

      calendar.className =
        "buyer-reg__safari-calendar";


      /*
       * Week names
       */
      var weekNames = [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
      ];


      var weekHeader =
        document.createElement("div");

      weekHeader.className =
        "buyer-reg__safari-weekdays";


      weekNames.forEach(
        function (name) {
          var item =
            document.createElement("span");

          item.textContent = name;

          weekHeader.appendChild(
            item
          );
        }
      );


      var daysGrid =
        document.createElement("div");

      daysGrid.className =
        "buyer-reg__safari-days";


      calendar.appendChild(
        weekHeader
      );

      calendar.appendChild(
        daysGrid
      );


      /*
       * Add everything
       */
      safariPicker.appendChild(
        selectRow
      );

      safariPicker.appendChild(
        calendar
      );

      wrap.appendChild(
        safariPicker
      );


      /*
       * =================================
       * RENDER CALENDAR
       * =================================
       */

      function renderCalendar() {
        var selectedYear =
          parseInt(
            yearSelect.value,
            10
          );

        var selectedMonth =
          parseInt(
            monthSelect.value,
            10
          );


        daysGrid.innerHTML = "";


        /*
         * First weekday
         */
        var firstDay =
          new Date(
            selectedYear,
            selectedMonth - 1,
            1
          ).getDay();


        /*
         * Days in month
         */
        var daysInMonth =
          new Date(
            selectedYear,
            selectedMonth,
            0
          ).getDate();


        /*
         * Blank cells
         */
        for (
          var blank = 0;
          blank < firstDay;
          blank++
        ) {
          var empty =
            document.createElement(
              "span"
            );

          empty.className =
            "buyer-reg__safari-day-empty";

          daysGrid.appendChild(
            empty
          );
        }


        /*
         * Actual days
         */
        for (
          var day = 1;
          day <= daysInMonth;
          day++
        ) {
          (function (
            selectedDay
          ) {
            var dayButton =
              document.createElement(
                "button"
              );

            dayButton.type =
              "button";

            dayButton.className =
              "buyer-reg__safari-day";

            dayButton.textContent =
              selectedDay;


            /*
             * Prevent dates newer
             * than 18 years
             */
            var candidateDate =
              new Date(
                selectedYear,
                selectedMonth - 1,
                selectedDay
              );


            if (
              candidateDate >
              maxDOB
            ) {
              dayButton.disabled =
                true;
            }


            /*
             * Highlight current
             * selected DOB
             */
            var currentMatch =
              textInput.value.match(
                /^(\d{2})\/(\d{2})\/(\d{4})$/
              );


            if (
              currentMatch &&
              parseInt(
                currentMatch[1],
                10
              ) === selectedDay &&
              parseInt(
                currentMatch[2],
                10
              ) === selectedMonth &&
              parseInt(
                currentMatch[3],
                10
              ) === selectedYear
            ) {
              dayButton.classList.add(
                "buyer-reg__safari-day--selected"
              );
            }


            dayButton.addEventListener(
              "click",
              function () {
                var dd =
                  String(
                    selectedDay
                  ).padStart(
                    2,
                    "0"
                  );

                var mm =
                  String(
                    selectedMonth
                  ).padStart(
                    2,
                    "0"
                  );


                textInput.value =
                  dd +
                  "/" +
                  mm +
                  "/" +
                  selectedYear;


                /*
                 * Keep your hidden
                 * native input synced
                 */
                pickerInput.value =
                  selectedYear +
                  "-" +
                  mm +
                  "-" +
                  dd;


                textInput.dispatchEvent(
                  new Event(
                    "input",
                    {
                      bubbles: true
                    }
                  )
                );

                textInput.dispatchEvent(
                  new Event(
                    "change",
                    {
                      bubbles: true
                    }
                  )
                );


                validateField(
                  textInput
                );


                safariPicker.hidden =
                  true;
              }
            );


            daysGrid.appendChild(
              dayButton
            );
          })(day);
        }
      }


      /*
       * =================================
       * OPEN SAFARI PICKER
       * =================================
       */

      function openSafariPicker(
        event
      ) {
        if (
          event
        ) {
          event.preventDefault();
        }

        if (
          textInput.disabled
        ) {
          return;
        }


        /*
         * Existing DOB?
         */
        var match =
          textInput.value.match(
            /^(\d{2})\/(\d{2})\/(\d{4})$/
          );


        if (match) {
          monthSelect.value =
            String(
              parseInt(
                match[2],
                10
              )
            );

          yearSelect.value =
            match[3];
        } else {
          monthSelect.value =
            String(
              maxDOB.getMonth() + 1
            );

          yearSelect.value =
            String(maxYear);
        }


        renderCalendar();

        safariPicker.hidden =
          !safariPicker.hidden;
      }


      /*
       * Clicking DOB opens
       * Safari-only picker
       */
      textInput.addEventListener(
        "click",
        openSafariPicker
      );


      /*
       * Calendar icon area
       */
      wrap.addEventListener(
        "click",
        function (event) {
          if (
            event.target ===
            safariPicker ||
            safariPicker.contains(
              event.target
            )
          ) {
            return;
          }

          if (
            event.target ===
            textInput
          ) {
            return;
          }

          openSafariPicker(
            event
          );
        }
      );


      /*
       * Month change
       */
      monthSelect.addEventListener(
        "change",
        renderCalendar
      );


      /*
       * Year change
       */
      yearSelect.addEventListener(
        "change",
        renderCalendar
      );


      /*
       * Close when clicking
       * outside
       */
      document.addEventListener(
        "click",
        function (event) {
          if (
            !wrap.contains(
              event.target
            )
          ) {
            safariPicker.hidden =
              true;
          }
        }
      );
    });
}

  function bindTypeTabs(formEl, totalSteps) {
    var tabs = formEl.querySelectorAll(".buyer-reg__tab");
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        tabs.forEach(function (t) {
          t.classList.remove("buyer-reg__tab--active");
          t.setAttribute("aria-selected", "false");
        });
        tab.classList.add("buyer-reg__tab--active");
        tab.setAttribute("aria-selected", "true");
        var statusEl = formEl.querySelector("[data-buyer-status]");
        setStatus(statusEl, null, "");
        setContentMode(formEl, tab.getAttribute("data-type"), totalSteps);
      });
    });
  }

  function bindSectorBadges(formEl, sectionId, onSave) {
    var container = formEl.querySelector("[data-sector-badges]");
    if (!container) return;
    var hiddenInput = document.getElementById("BusinessSector-" + sectionId);
    var badges = container.querySelectorAll(".buyer-reg__sector-badge");

    badges.forEach(function (badge) {
      badge.addEventListener("click", function () {
        badges.forEach(function (b) {
          b.classList.remove("buyer-reg__sector-badge--active");
        });
        badge.classList.add("buyer-reg__sector-badge--active");
        if (hiddenInput) {
          hiddenInput.value = badge.getAttribute("data-sector");
          // Clear sector validation error
          var sectorErr = formEl.querySelector(
            '[data-error-for="' + hiddenInput.id + '"]',
          );
          if (sectorErr) sectorErr.textContent = "";
          var sectorField = hiddenInput.closest(".buyer-reg__field");
          if (sectorField) sectorField.classList.remove("has-error");
          // Save draft immediately (hidden input change doesn't fire input/change events)
          if (onSave) onSave();
        }
      });
    });
  }

  function updateCompanyType(sectionId) {
    var companyType = document.getElementById("BusinessType-" + sectionId);
    var companiesWrap = document.getElementById(
      "CompaniesHouseWrap-" + sectionId,
    );
    var companiesInput = document.getElementById("CompaniesHouse-" + sectionId);
    if (!companyType || !companiesWrap || !companiesInput) return;

    var v = companyType.value.trim().toLowerCase();
    var needCh = v === "ltd" || v === "llp";
    companiesWrap.hidden = !needCh;
    companiesInput.required = needCh;
    companiesInput.disabled = !needCh;
    if (!needCh) {
      companiesInput.value = "";
      displayFieldError(companiesInput, "");
    }
  }

  function bindSubmit(formEl, sectionId) {
    if (!formEl || formEl.dataset.buyerRegSubmitBound === "1") return;
    formEl.dataset.buyerRegSubmitBound = "1";

    formEl.addEventListener("submit", async function (e) {
      e.preventDefault();

      // Validate all enabled required fields
      var allValid = true;
      formEl
        .querySelectorAll(
          "input[required]:not(:disabled), select[required]:not(:disabled), textarea[required]:not(:disabled)",
        )
        .forEach(function (input) {
          if (!validateField(input)) allValid = false;
        });
      if (!allValid) return;

      // Require a proof-of-age document when the age confirmation is checked
      if (!isAgeProofSatisfied(formEl)) {
        showAgeProofError(
          formEl,
          "Please upload a proof of age document before submitting.",
        );
        var ageInput = formEl.querySelector("[data-age-proof-input]");
        if (ageInput) ageInput.focus();
        return;
      }

      var root = formEl.closest("[data-buyer-registration]");
      var apiUrl =
        (root && root.getAttribute("data-buyer-api-url")) || BUYERS_API_URL;
      var existingBuyerId = root && root.getAttribute("data-buyer-id");
      var isUpdate = !!(existingBuyerId && existingBuyerId.trim());
      var requestUrl = isUpdate
        ? apiUrl + encodeURIComponent(existingBuyerId.trim()) + "/"
        : apiUrl;
      var requestMethod = isUpdate ? "PATCH" : "POST";
      var customerId = root && root.getAttribute("data-customer-id");
      var signatureSecret =
        "0e8ee093b879692c9f9a1dbf3618444588a14f5e1a9e711fa7e02b5d84c416d3";
      var statusEl = formEl.querySelector("[data-buyer-status]");
      var submitBtn = formEl.querySelector("[data-submit-button]");

      var payload = buildBuyersApiPayload(formEl);

      setStatus(statusEl, null, "");

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute("aria-busy", "true");
      }

      try {
        
        var headers = {
          Accept: "application/json",
          };

      if (customerId && signatureSecret) {
       var signature = await getSignature(customerId, signatureSecret);
        headers["X-Customer-Id"] = customerId;
        headers["X-Shopify-Signature"] = signature;
      }

      var requestBody;

      if (!isUpdate && payload.business_type === "INDIVIDUAL") {
      var ageProofInput = formEl.querySelector("[data-age-proof-input]");
       var ageProofFile =
      ageProofInput &&
      ageProofInput.files &&
      ageProofInput.files.length
      ? ageProofInput.files[0]
      : null;

      var formData = new FormData();

      formData.append("name", payload.name);
      formData.append("email", payload.email);
       formData.append("phone", payload.phone);
      formData.append("business_type", payload.business_type);
      formData.append("metadata", JSON.stringify(payload.metadata));

      if (payload.date_of_birth) {
        formData.append("date_of_birth", payload.date_of_birth);
      }

      formData.append(
        "age_confirmation",
        payload.age_confirmation ? "true" : "false",
      );

      if (ageProofFile) {
        formData.append("proof_of_age", ageProofFile);
      }

       requestBody = formData;
      } else {
      headers["Content-Type"] = "application/json";
      requestBody = JSON.stringify(payload);
      }

var res = await fetch(requestUrl, {
  method: requestMethod,
  headers: headers,
  body: requestBody,
});

        var text = await res.text();
        var body = null;
        if (text) {
          try {
            body = JSON.parse(text);
          } catch (err) {
            body = { raw: text };
          }
        }

        if (res.ok) {
          var collected = collectContactFields(formEl);
          var proofFiles = collected.files;
          var buyerId =
            (body && body.id) || (isUpdate ? existingBuyerId : null);
          var submittedEmail = collected.contact["email"] || "";
          if (
            proofFiles.length > 0 &&
             buyerId != null &&
            buyerId !== "" &&
            isUpdate
          ) {
          uploadBuyerProofOfAge(buyerId, proofFiles, true).catch(
          function () {},
          );
          }
          formEl.reset();
          clearFormDraft(sectionId);
          try {
            localStorage.setItem("buyer_form_filled", "true");
          } catch (e) {}
          try {
            localStorage.setItem("is_form_submitted", "true");
          } catch (e) {}
          if (root)
            showBuyerSuccess(
              root,
              formEl,
              submittedEmail,
              payload.business_type,
            );
        } else {
          var errMsg;
          if (
            body &&
            typeof body === "object" &&
            !body.detail &&
            !body.message &&
            !body.error
          ) {
            var fieldErrors = Object.keys(body).reduce(function (acc, field) {
              var msgs = Array.isArray(body[field])
                ? body[field]
                : [body[field]];
              return acc.concat(msgs.filter(Boolean));
            }, []);
            errMsg = fieldErrors.length
              ? fieldErrors
              : "Something went wrong. Please try again.";
          } else {
            var rawMsg = body && (body.detail || body.message || body.error);
            if (typeof rawMsg === "object") rawMsg = JSON.stringify(rawMsg);
            errMsg = rawMsg || "Something went wrong. Please try again.";
          }
          setStatus(statusEl, "error", errMsg);
        }
      } catch (err) {
        setStatus(
          statusEl,
          "error",
          "Could not reach the server. Check your connection or try again later.",
        );
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute("aria-busy");
        }
      }
    });
  }

  var DRAFT_KEY_PREFIX = "buyer-reg-draft-";

  // Save only the fields belonging to a specific step
  function saveStepDraft(formEl, sectionId, stepNum) {
    var raw;
    try {
      raw = localStorage.getItem(DRAFT_KEY_PREFIX + sectionId);
    } catch (e) {}
    var draft = {};
    try {
      if (raw) draft = JSON.parse(raw);
    } catch (e) {}
    if (!draft.steps) draft.steps = {};

    draft.currentStep = stepNum;

    var stepContent = formEl.querySelector(
      '[data-step-content="' + stepNum + '"]',
    );
    var stepData = {};
    if (stepContent) {
      stepContent
        .querySelectorAll("input, select, textarea")
        .forEach(function (field) {
          if (!field.name) return;
          if (field.type === "password" || field.type === "file") return;
          if (field.readOnly) return;
          if (field.type === "checkbox") {
            stepData[field.name + ":checked"] = field.checked;
          } else {
            var val = field.value;
            if (field.getAttribute("data-validation-type") === "phone" && val) {
              var digits = val.trim().replace(/^0/, "");
              val = "+44" + digits;
            }
            stepData[field.name] = val;
          }
        });
    }
    draft.steps[stepNum] = stepData;

    try {
      localStorage.setItem(DRAFT_KEY_PREFIX + sectionId, JSON.stringify(draft));
    } catch (e) {}
  }

  // Restore all saved steps and return the last active step number
  function restoreFormDraft(formEl, sectionId) {
    var raw;
    try {
      raw = localStorage.getItem(DRAFT_KEY_PREFIX + sectionId);
    } catch (e) {}
    if (!raw) return 1;

    var draft;
    try {
      draft = JSON.parse(raw);
    } catch (e) {
      return 1;
    }
    if (!draft.steps) return 1;

    Object.keys(draft.steps).forEach(function (stepNum) {
      var stepData = draft.steps[stepNum];
      var stepContent = formEl.querySelector(
        '[data-step-content="' + stepNum + '"]',
      );
      if (!stepContent) return;

      stepContent
        .querySelectorAll("input, select, textarea")
        .forEach(function (field) {
          if (!field.name) return;
          if (field.type === "password" || field.type === "file") return;
          if (field.readOnly) return;
          if (field.type === "checkbox") {
            var checked = stepData[field.name + ":checked"];
            if (checked !== undefined) field.checked = checked;
          } else {
            var val = stepData[field.name];
            if (val !== undefined) {
              // Phone fields are stored with +44 — strip it back for the input
              if (
                field.getAttribute("data-validation-type") === "phone" &&
                typeof val === "string" &&
                val.startsWith("+44")
              ) {
                val = val.slice(3);
              }
              field.value = val;
            }
          }
        });
    });

    // Restore sector badge active state
    var sectorInput = document.getElementById("BusinessSector-" + sectionId);
    if (sectorInput && sectorInput.value) {
      var badge = formEl.querySelector(
        '.buyer-reg__sector-badge[data-sector="' + sectorInput.value + '"]',
      );
      if (badge) badge.classList.add("buyer-reg__sector-badge--active");
    }

    return parseInt(draft.currentStep, 10) || 1;
  }

  function updateDraftStep(sectionId, stepNum) {
    var raw;
    try {
      raw = localStorage.getItem(DRAFT_KEY_PREFIX + sectionId);
    } catch (e) {}
    var draft = {};
    try {
      if (raw) draft = JSON.parse(raw);
    } catch (e) {}
    draft.currentStep = stepNum;
    try {
      localStorage.setItem(DRAFT_KEY_PREFIX + sectionId, JSON.stringify(draft));
    } catch (e) {}
  }

  function clearFormDraft(sectionId) {
    try {
      localStorage.removeItem(DRAFT_KEY_PREFIX + sectionId);
    } catch (e) {}
  }

  function bindDraftSave(formEl, sectionId, getCurrentStep) {
    var timer;
    function scheduleSave() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        saveStepDraft(formEl, sectionId, getCurrentStep());
      }, 400);
    }
    formEl.addEventListener("input", function (e) {
      var t = e.target;
      if (t.type === "password" || t.type === "file") return;
      scheduleSave();
    });
    formEl.addEventListener("change", function (e) {
      var t = e.target;
      if (t.type === "password" || t.type === "file") return;
      scheduleSave();
    });
  }

  function bindAgeUploadToggle(formEl, sectionId) {
    var root = formEl.closest("[data-buyer-registration]");
    var existingBuyerId = root && root.getAttribute("data-buyer-id");

    var checkbox = document.getElementById("IndAgeConfirmation-" + sectionId);
    var uploadWrap = document.getElementById("IndAgeUpload-" + sectionId);
    if (!checkbox || !uploadWrap) return;

    var fileInput = uploadWrap.querySelector("[data-age-proof-input]");
    var selectedEl = uploadWrap.querySelector("[data-age-upload-selected]");

    if (
      existingBuyerId &&
      !uploadWrap.querySelector(".buyer-reg__age-upload-warning")
    ) {
      var warning = document.createElement("p");
      warning.className = "buyer-reg__age-upload-warning";
      warning.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>' +
        "A file has already been uploaded. Uploading a new file will replace the existing one.";
      uploadWrap.insertBefore(warning, uploadWrap.firstChild);
    }

    function toggle() {
      var show = checkbox.checked;
      uploadWrap.hidden = !show;
      if (fileInput) {
        fileInput.disabled = !show;
        if (!show) {
          fileInput.value = "";
          if (selectedEl) {
            selectedEl.textContent = "";
            selectedEl.hidden = true;
          }
        }
      }
    }

    checkbox.addEventListener("change", toggle);

    if (fileInput && selectedEl) {
      fileInput.addEventListener("change", function () {
        if (fileInput.files && fileInput.files.length > 0) {
          if (fileInput && selectedEl) {
  fileInput.addEventListener("change", function () {
    if (fileInput.files && fileInput.files.length > 0) {
      if (fileInput.files.length > 2) {
        fileInput.value = "";
        selectedEl.textContent = "You can upload a maximum of 2 files.";
        selectedEl.className =
          "buyer-reg__age-upload-selected buyer-reg__age-upload-selected--error";
        selectedEl.hidden = false;
        return;
      }

      var names = Array.from(fileInput.files)
        .map(function (f) {
          return f.name;
        })
        .join(", ");

      selectedEl.textContent = names;
      selectedEl.className = "buyer-reg__age-upload-selected";
      selectedEl.hidden = false;
    } else {
      selectedEl.textContent = "";
      selectedEl.className = "buyer-reg__age-upload-selected";
      selectedEl.hidden = true;
    }
  });
}
          var names = Array.from(fileInput.files)
            .map(function (f) {
              return f.name;
            })
            .join(", ");
          selectedEl.textContent = names;
          selectedEl.className = "buyer-reg__age-upload-selected";
          selectedEl.hidden = false;
        } else {
          selectedEl.textContent = "";
          selectedEl.className = "buyer-reg__age-upload-selected";
          selectedEl.hidden = true;
        }
      });
    }

    toggle();
  }

  function bindSubmitCheckboxGate(formEl) {
    var submitBtn = formEl.querySelector("[data-submit-button]");
    if (!submitBtn) return;

    function updateSubmitState() {
      var allChecked = true;
      formEl
        .querySelectorAll("input[type='checkbox'][required]:not(:disabled)")
        .forEach(function (cb) {
          if (!cb.checked) allChecked = false;
        });
      submitBtn.disabled = !allChecked || !isAgeProofSatisfied(formEl);
    }

    formEl.querySelectorAll("input[type='checkbox']").forEach(function (cb) {
      cb.addEventListener("change", updateSubmitState);
    });

    var ageProofInput = formEl.querySelector("[data-age-proof-input]");
    if (ageProofInput) {
      ageProofInput.addEventListener("change", updateSubmitState);
    }

    updateSubmitState();
    return updateSubmitState;
  }

  function initRoot(root) {
    var sectionId = root.getAttribute("data-section-id");
    if (!sectionId) return;

    var formEl = document.getElementById("BuyerRegistrationForm-" + sectionId);
    if (!formEl) return;

    var totalSteps = 4;

    // Companies House show/hide based on company type
    var companyTypeEl = document.getElementById("BusinessType-" + sectionId);
    if (companyTypeEl) {
      companyTypeEl.addEventListener("input", function () {
        updateCompanyType(sectionId);
      });
      updateCompanyType(sectionId);
    }

    bindTypeTabs(formEl, totalSteps);
    bindDOBPicker(formEl);
    bindFieldValidation(formEl);

    var nav = bindFormNavigation(formEl, totalSteps, sectionId);

    bindSectorBadges(formEl, sectionId, function () {
      saveStepDraft(formEl, sectionId, nav.getCurrentStep());
    });
    bindDraftSave(formEl, sectionId, nav.getCurrentStep);
    bindSubmit(formEl, sectionId);
    bindAgeUploadToggle(formEl, sectionId);
    var updateSubmitState = bindSubmitCheckboxGate(formEl);

    var savedStep = restoreFormDraft(formEl, sectionId);
    nav.goToStep(savedStep);
    var activeTabEl = formEl.querySelector(".buyer-reg__tab--active");
    if (activeTabEl) {
      setContentMode(formEl, activeTabEl.getAttribute("data-type"), totalSteps);
    }
    if (updateSubmitState) updateSubmitState();
  }

  function initAll() {
    document.querySelectorAll("[data-buyer-registration]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-buyer-registration]");
    if (root) initRoot(root);
  });
})();
